import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { RootState } from '../../../../app/providers/Store'

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
